import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TIndirectTaxExposureV2Response } from './types';

export function useIndirectTaxExposure({
  corporationId,
}: {
  corporationId: number;
}) {
  const { data, mutate, error, isLoading } =
    useSWR<TIndirectTaxExposureV2Response>(
      corporationId
        ? `new-sales-tax/exposure?corporationId=${corporationId}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined)
    );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
